module.exports = __webpack_public_path__ + "img/Italian Salad-Sopressata.79ae8ad9.jpg";